<template>
  <div id="subpage">
    <el-col :span="24" class="warp-breadcrum">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>
          <b>厂商管理</b>
        </el-breadcrumb-item>
        <el-breadcrumb-item>厂商列表</el-breadcrumb-item>
      </el-breadcrumb>
    </el-col>
    <div class="content">
      <div class="xcx-head">
        <div style="display: flex">
          <span>厂商列表</span>
        </div>
        <div style="display: flex">
          <el-button @click="add()" icon="el-icon-plus" type="primary">添加厂商</el-button>
          <el-button @click="dialogFormSwitch = true" icon="el-icon-bottom" type="warning">批量导入</el-button>
        </div>
      </div>
      <div class="search-box mt10">
        <el-form :inline="true">
          <el-form-item>
            <el-input placeholder="请输入关键词" v-model="search.keys"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button @click="getIndex()" icon="el-icon-search" type="primary">查询</el-button>
          </el-form-item>
          <el-form-item>
            <el-button @click="getClearIndex()" icon="el-icon-delete" type="info">清空筛选</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="xcx-content">
        <!--列表-->
        <el-table border :data="tableData" stripe style="width: 100%" v-loading="loading">
          <el-table-column prop="id" label="ID" width="50"></el-table-column>
          <el-table-column prop="brand" label="房车品牌" width="80"></el-table-column>
          <el-table-column prop="title" label="厂商名称 " width="150"></el-table-column>
          <el-table-column prop="nums" label="设备数量" width="100"></el-table-column>
          <el-table-column prop="city" label="城市" width="260"></el-table-column>
          <el-table-column prop="contacts" label="联系人" width="140"></el-table-column>
          <el-table-column prop="mobile" label="联系方式" width="140"></el-table-column>
          <el-table-column prop="stime" label="联系日期" width="140"></el-table-column>
          <el-table-column prop="address" label="详细地址" width="320"></el-table-column>
          <el-table-column prop="desc" label="备注" width="80"></el-table-column>
          <el-table-column prop="created_at" width="160" label="添加时间"></el-table-column>
          <el-table-column fixed="right" label="操作" width="160">
            <template #default="scope">
              <el-button size="mini" @click="edit(scope.row.id)">编辑</el-button>
              <el-button size="mini" type="danger" @click="del_item(scope.row.id)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <!--分页-->
        <div class="paging">
          <el-pagination class="left" @current-change="handleCurrentChange" :current-page="page" background
            layout="total,prev, pager, next" :total="count"></el-pagination>
        </div>
      </div>
    </div>

    <!-- 导入开关 -->
    <el-dialog title="批量导入设备" width="33%" :visible.sync="dialogFormSwitch">
      <el-form :model="filesForm" :rules="files_rules" ref="filesForm">
        <el-form-item label="上传文件：" :label-width="formLabelWidth" prop="filesUrl">
          <el-upload class="upload-demo" name="image" action="https://api.iztrv.com/uploadfile"
            :on-success="handleAvatarSuccess" :before-remove="beforeRemove" multiple :limit="1"
            :on-exceed="handleExceed" :file-list="fileList">
            <el-button size="small" type="primary">点击上传</el-button>
            <div slot="tip" class="el-upload__tip">只能上传xlsx文件，且不超过500kb</div>
          </el-upload>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormSwitch = false">取 消</el-button>
        <el-button type="primary" @click="submitImportForm('filesForm')">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      loading: true,
      tableData: [],
      page: 0,
      count: 0,
      limit: 10,
      search: {
        keys: "",
      },
      dialogFormSwitch: false,
      fileList: [],
      filesForm: {
        filesUrl: "",
      },
      files_rules: {
        filesUrl: [
          { required: true, message: "请上传文件", trigger: "change" },
        ],
      },
    };
  },
  //进入页面加载
  mounted: function () {
    var that = this;
    that.getList();
  },
  methods: {
    add() {
      this.$router.push("/factory/add_company");
    },
    edit(ids) {
      this.$router.push({
        path: "/factory/add_company",
        query: {
          id: ids,
        },
      });
    },
    /**
     * 下一页
     */
    handleCurrentChange(currentPage) {
      var that = this;
      that.page = currentPage;
      that.getList();
    },
    del_item(ids) {
      let that = this;
      this.$confirm("此操作不可逆, 是否继续?", "温馨提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          that.axios
            .post("/company/destroy", {
              ids: ids,
            })
            .then((res) => {
              console.log(res);
              if (res.code == 200) {
                this.$message({
                  type: "success",
                  message: res.msg,
                });
                that.getList();
              } else {
                this.$message({
                  type: "info",
                  message: res.msg,
                });
              }
            });
        })
        .catch(() => { });
    },
    getIndex() {
      this.getList();
    },
    getClearIndex() {
      this.search.keys = "";
      this.getList();
    },
    /**
     * 获取列表
     */
    getList() {
      let that = this;
      let formData = {};
      var curr_page = sessionStorage.getItem("curr_page");
      that.page = curr_page ? curr_page - 0 : that.page;
      formData.page = that.page;
      formData.limit = that.limit;
      formData.keys = that.search.keys;
      that.axios.post("/company/index", formData).then((res) => {
        if (res) {
          that.tableData = res.data.data;
          that.count = res.data.total;
          that.page = curr_page ? curr_page : that.page;
          curr_page ? sessionStorage.removeItem("curr_page") : "";
          that.loading = false;
        }
      });
    },

    handleAvatarSuccess(res, file) {
      this.filesForm.filesUrl = res.msg;
    },
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 3 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length
        } 个文件`
      );
    },
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`);
    },

    submitImportForm(formName) {
      const that = this;
      that.$refs[formName].validate((valid) => {
        if (!valid) return that.$message.warning("请完整填写内容!");
        var formData = {};
        formData = that.filesForm;
        var url = "/company/import";
        that.axios.post(url, formData).then(() => {
          that.$message.success("批量导入成功");
          that.dialogFormSwitch = false;
          that.filesForm.filesUrl = "";
          that.getList();
        });
      });
    },
  },
};
</script>
<style>
.search-box {
  padding: 0 20px;
}
</style>